/**
 * Ajuda dos campos do termo de uso e do termo de aceite (P-USU-2).
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6, e docs/ADR/0037-termo-de-uso-e-termo-de-aceite.md.
 */

/**
 * Campos das versoes e da configuracao do aceite. Aparecem em duas telas: na aba
 * Termos de /configuracoes (a ajuda de settings.ts os junta) e na aba Versoes dos
 * termos de /termos-aceite.
 */
export const ajudaDasVersoesDosTermos: Record<string, string> = {
  'Bloquear o uso ate o aceite':
    'Ligada, a moldura bloqueia o uso de quem ainda nao aceitou a versao vigente, ate o clique. Nasce desligada: a regra CPO-021 nao foi homologada. Exige a alcada de aprovacao do termo.',
  'Publico do termo':
    'Para quem o termo de uso vale: so as pessoas das corretoras (o termo do corretor) ou todas as pessoas da empresa.',
  'Tipo de termo de aceite':
    'Onde o termo aparece: na emissao da apolice, na solicitacao de endosso ou na nova cotacao da corretora. Cada tipo tem as proprias versoes.',
  'Titulo da versao':
    'Titulo que a pessoa le no alto do termo. Obrigatorio para ativar. Ate 200 caracteres.',
  'Texto do termo':
    'Texto da seguradora, com a formatacao do editor. O servidor saneia o HTML de novo ao gravar. Obrigatorio para ativar; depois de ativa, a versao nao muda.',
  'Observacao da versao':
    'Nota interna da versao, como a norma citada ou o motivo da nova redacao. Nao aparece para quem aceita.',
  'Justificativa da ativacao':
    'Obrigatoria. Fica na versao e na trilha. Quem escreveu ou editou o rascunho nao ativa.',
  'Motivo da revogacao':
    'Obrigatorio. A versao sai de vigor sem substituta e fica guardada como revogada.',
};

export const ajuda: Record<string, Record<string, string>> = {
  '/termos-aceite': {
    Corretora:
      'Mostra so os aceites das pessoas da corretora escolhida. Sem a escolha, a lista traz todas as corretoras e as pessoas da seguradora.',
    'Tipo de termo':
      'Emissao da apolice, solicitacao de endosso ou nova cotacao da corretora: onde a pessoa declarou o termo de aceite.',
    ...ajudaDasVersoesDosTermos,
  },
};
